export class CustomField {
  id: number;
  name: string;
  type: string;
  insAt: string;
}
